import { useNavigate } from "react-router-dom";
import ImageLinks from "../../../assets/Images/ImagesLink";
import { shallowEqual, useSelector } from "react-redux";
import _ from "lodash";
import { ChevronRight, SearchIcon } from "../../../assets/whiteLabelIcon";
import { useTranslation } from "react-i18next";

const QuickPackage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { sender_details } = useSelector((state) => state.app, shallowEqual);
  return (
    <div className="flex flex-col items-start px-5 py-5 w-full bg-white rounded-lg shadow-[0px_0px_8px_rgba(166,166,166,0.25)]">
      <div className="flex gap-1.5">
        <img
          loading="lazy"
          src={ImageLinks.bxs_package}
          alt=""
          className="object-contain shrink-0 w-5 aspect-square"
        />
        <p className="font-custom text-sm font-semibold	text-dark_black">
          {t("deliver_package")}
        </p>
      </div>
      <div className="flex gap-[12px] mt-4 items-center pl-[6px]">
        <div className={`h-2 w-2 rounded-full bg-secondary`}></div>
        <div
          className="flex gap-[5px] items-center"
          onClick={() =>
            !_.isEmpty(sender_details) && navigate("/set-pickup-address")
          }
        >
          <p
            className={`font-custom text-xs font-medium text-${
              _.isEmpty(sender_details) ? "gray" : "secondary"
            }`}
          >
            {t("pickup_address")}
          </p>
          {!_.isEmpty(sender_details) && <ChevronRight />}
        </div>
      </div>
      <div
        className="flex flex-col pl-[26px] w-full"
        onClick={() => navigate("/set-pickup-address")}
      >
        <div
          className={`flex justify-${
            _.isEmpty(sender_details) ? "start" : "between"
          } items-center gap-1`}
          onClick={() =>
            _.isEmpty(sender_details) && navigate("/set-pickup-address")
          }
        >
          <p
            className={`line-clamp-2 font-custom font-bold text-sm text-${
              _.isEmpty(sender_details) ? "secondary" : "dark_black"
            }`}
          >
            {!_.isEmpty(sender_details)
              ? sender_details?.address_line1
              : "Add address details for pickup"}
          </p>
          {_.isEmpty(sender_details) && <ChevronRight />}
          {!_.isEmpty(sender_details?.label) && (
            <div className="py-[3px] px-[5px] rounded-[8px] bg-accents">
              <p className="font-custom font-medium	text-[8px] text-secondary line-clamp-1">
                {sender_details?.label}
              </p>
            </div>
          )}
        </div>
        <p className="line-clamp-1 font-custom font-semibold text-[10px] text-dark_gray">
          {/* {sender_details?.address_line1} */}
          {sender_details?.formatted_address}
        </p>
        {!_.isEmpty(sender_details?.name) && (
          <div className="flex gap-1.5">
            <p className="font-custom font-semibold text-[10px] text-dark_gray">
              {sender_details?.name}
            </p>
            <img src={ImageLinks.vector_40} />
            <p className="font-custom font-semibold text-[10px] text-dark_gray">
              {sender_details?.mobile}
            </p>
          </div>
        )}
        {!_.isEmpty(sender_details) && _.isEmpty(sender_details.name) && (
          <p className="font-custom font-semibold text-[10px] text-error">
            {t("please_add_sender_details")}
          </p>
        )}
      </div>
      <div className="flex gap-[12px] mt-4 items-center pl-[6px]">
        <div className={`h-2 w-2 rounded-full border border-secondary`}></div>

        <div className="flex gap-[5px] items-center ">
          <p className="font-custom text-xs font-medium text-secondary">
            {t("delivery_address")}
          </p>
        </div>
      </div>
      <div className="mt-[6px] w-full relative">
        <input
          type="text"
          id="saveAddress"
          name="saveAddress"
          className="font-custom bg-gray-50 border border-accents text-dark_black text-sm font-medium rounded-[21px] w-full pt-[8px] pr-[11px] pb-[8px] pl-[24px]"
          placeholder={`${t("deliver_to")}?`}
          // onClick={() => navigate("/set-delivery-address")}
          onClick={() => navigate(`/search-location?type=delivery&from=null`)}
        />
        <div className="absolute top-[10px] right-[10px] w-[16px] h-[16px] aspect-square">
          <SearchIcon />
        </div>
      </div>
    </div>
  );
};

export default QuickPackage;
